import React from 'react';

const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { container: "w-8 h-8", text: "text-lg" },
    default: { container: "w-10 h-10", text: "text-xl" },
    large: { container: "w-16 h-16", text: "text-3xl" }
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer Circle with Gradient */}
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#10b981', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#059669', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="letterGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#f0fdf4', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Background Circle */}
      <circle cx="100" cy="100" r="95" fill="url(#logoGradient)" />
      
      {/* Inner decorative elements - representing connectivity/technology */}
      <path
        d="M 60 100 L 80 80 L 100 100 L 120 80 L 140 100"
        stroke="rgba(255,255,255,0.2)"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Digital nodes */}
      <circle cx="60" cy="100" r="4" fill="white" opacity="0.6" />
      <circle cx="80" cy="80" r="4" fill="white" opacity="0.6" />
      <circle cx="100" cy="100" r="4" fill="white" opacity="0.6" />
      <circle cx="120" cy="80" r="4" fill="white" opacity="0.6" />
      <circle cx="140" cy="100" r="4" fill="white" opacity="0.6" />
      
      {/* TYJ Text */}
      <text
        x="100"
        y="135"
        fontFamily="Arial, sans-serif"
        fontSize="60"
        fontWeight="bold"
        fill="url(#letterGradient)"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        TYJ
      </text>
    </svg>
  );
};

export default Logo;
